import { render, staticRenderFns } from "./textViewer.vue?vue&type=template&id=6da08fd2&scoped=true&"
import script from "./textViewer.vue?vue&type=script&lang=js&"
export * from "./textViewer.vue?vue&type=script&lang=js&"
import style0 from "./textViewer.vue?vue&type=style&index=0&id=6da08fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da08fd2",
  null
  
)

export default component.exports